import Vue from 'vue'
import App from './App.vue'

import router from './router'
import vuex from './vuex'
import axios from './axios'

import errorHandling from './errorHandling.js'

import moment from 'moment'
import clone from 'clone'

import 'babel-polyfill'

import vuetify from './plugins/vuetify';

import vueHeadful from 'vue-headful';
Vue.component('vue-headful', vueHeadful);

Vue.prototype.$axios = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$clone = clone;

new Vue({
  router,
  vuetify,
  store: vuex,
  render: h => h(App)
}).$mount('#app');
